import { Box, ResponsiveContext, Text } from "grommet";
import React from "react";
import translate from "../../../i18n/translate";
import { getFirstPayAmount } from "../../../services/services";
import { STEP } from "../../../services/types";
import { isSmallDevis, toCurrency } from "../../../services/utils";

const ResPageControl = ({ devis, step, submitable = true, onPrev, onNext, checkout, saveDevis }) => {
    let leftHidden = step === STEP.presentation || step === STEP.payment;
    let rightHidden = step === STEP.payment;
    let rightLabel = step === STEP.recap ? `${translate('massure_pour')} ${toCurrency(getFirstPayAmount(devis))}` : translate('suivant');

    const _onNext = () => {
        if (step === STEP.recap) {
            saveDevis();
            checkout();
            return;
        }
        onNext();
    }

    return (
        <ResponsiveContext.Consumer>
            {size => (
                isSmallDevis(size) ?
                    <Box width={'full'} direction='row' style={{ position: 'fixed', bottom: 0, height: 50 }}>
                        {
                            !leftHidden && submitable ?
                                <Box width={'full'} style={{ height: 50 }} justify='center' align="center" onClick={onPrev} background='#59A4F4'>
                                    <Text color={'#fff'}>{translate('retour')}</Text>
                                </Box> : null
                        }
                        {
                            !rightHidden && submitable ?
                                <Box width={'full'} style={{ height: 50 }} justify='center' align="center" onClick={_onNext} background='#E92C70'>
                                    <Text textAlign="center">{rightLabel}</Text>
                                </Box> : null
                        }
                    </Box> :
                    <Box />
            )}
        </ResponsiveContext.Consumer>
    )
}

export default ResPageControl;